import { render, staticRenderFns } from "./dlt.vue?vue&type=template&id=d771a6f8&scoped=true"
import script from "./dlt.vue?vue&type=script&lang=js"
export * from "./dlt.vue?vue&type=script&lang=js"
import style0 from "./dlt.vue?vue&type=style&index=0&id=d771a6f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d771a6f8",
  null
  
)

export default component.exports